if(!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.limit = this.dataset.limit;
      this.html = document.createElement('div');
      this.keenSliderContent = this.querySelector('.keen-slider-content');
      fetch(`/recommendations/products?product_id=${this.productId}&limit=${this.limit}&section_id=recommended_products_view`)
        .then(response => response.text())
        .then((text) => {
          this.html.innerHTML = text;
          const related = this.html.querySelector('.recommended-view');
      
          if(related && related.innerHTML.trim().length) this.keenSliderContent.innerHTML = related.innerHTML;

          this.querySelector('.title-target').append(this.querySelector('h2'));
        });
    }
  }
  customElements.define('recommended-products', RecommendedProducts);
}